import { useEffect } from "react";
import { useSelector } from "react-redux";

const usePageFetch = (match, callBack) => {
    const path = useSelector((state) => state.app.path);
    const decodedUri = decodeURIComponent(path.toLocaleLowerCase());
    const decodedMatchUrl = decodeURIComponent(match.url.toLocaleLowerCase());
    useEffect(() => {
        if (`/${decodedUri}` !== decodedMatchUrl) {
            callBack && callBack();
        }
    }, [match.url]);
};

export default usePageFetch;
